import React from "react";
import { FEEDLIST_UI_TYPES } from "../../../modules/stringConstants";
import { FeedButton, NumberText } from "./ColumnComponents";

const TEST_ID_PREFIX = "planning-tagStandardsFeed";

const getCustomComponent = ({ column, columnData, id }) => {
  const { uiType } = column;

  switch (uiType) {
    case FEEDLIST_UI_TYPES.TEXT:
      return columnData;
    case FEEDLIST_UI_TYPES.BUTTON:
      return (
        <FeedButton
          column={column}
          columnData={columnData}
          id={id}
          testId={TEST_ID_PREFIX}
        />
      );

    case FEEDLIST_UI_TYPES.NUMBER_TEXT:
      return <NumberText columnData={columnData} />;
    default:
      return null;
  }
};

export default getCustomComponent;
